import { createEventHub } from "@bokio/shared/services/api/signalRHub";

export interface ReceiptPredictionActivityEvent {
	CompanyId: string;
	ReceiptId: string;
	IsSuccessful: boolean;
}

export const receiptPredictionActivityHub = createEventHub<ReceiptPredictionActivityEvent>();
